export default __webpack_public_path__ + "static/media/bg.1a69cc3a.png";